const zIndex = {
  stopDemoBanner: 10001,
  popupTooltip: 1054,
  simulationPage: 1053,
  modalDialog: 1052,
  modal: 1051,
  modalOverlay: 1050,
  sheet: 1049,
  sidebar: 102,
  backdrop: 101,
  topbar: 100,
  testModeAlert: 99,
  sandboxModal: 80,
  fileInput: 15,
  dropdown: 10,
  dropdownOverlay: 9,
  tooltip: 7,
  searchClearButton: 4,
  paginationActive: 3,
  fieldActive: 3,
  buttonHover: 3,
  buttonActive: 2,
  pagination: 1,
  default: 1,
  below: -1,
  // TODO(ts-migration): `bottomSheetDialog` has always been `undefined` — consumers interpolating it
  // into styled-components emit the literal string "undefined" as a z-index value.
  bottomSheetDialog: undefined as undefined
} as const;

export type ZIndexName = keyof typeof zIndex;

export default zIndex;
